import { QwertyKeyboardKey } from './QwertyKeyboardKey'
import QwertyKeyboardRow from './QwertyKeyboardRow'

export type QwertyKey = {
  label: string
  size: string
  icon: null | string
  toggle: string
  disabled?: boolean
}

const numbersRow = [
  { label: '1', size: 'sm', icon: null, toggle: '' },
  { label: '2', size: 'sm', icon: null, toggle: '' },
  { label: '3', size: 'sm', icon: null, toggle: '' },
  { label: '4', size: 'sm', icon: null, toggle: '' },
  { label: '5', size: 'sm', icon: null, toggle: '' },
  { label: '6', size: 'sm', icon: null, toggle: '' },
  { label: '7', size: 'sm', icon: null, toggle: '' },
  { label: '8', size: 'sm', icon: null, toggle: '' },
  { label: '9', size: 'sm', icon: null, toggle: '' },
  { label: '0', size: 'sm', icon: null, toggle: '' },
  { label: 'Backspace', size: 'md', icon: 'icon-backspace', toggle: '' },
]

const actionsRow = [
  { label: 'Clear', size: 'lg', icon: 'icon-trash', toggle: '' },
  { label: 'Space', size: 'lg', icon: 'icon-space', toggle: '' },
  { label: 'Done', size: 'lg', icon: null, toggle: '' },
]

export const keyboardLayouts = {
  lowercase: [
    [
      { label: 'q', size: 'sm' },
      { label: 'w', size: 'sm' },
      { label: 'e', size: 'sm' },
      { label: 'r', size: 'sm' },
      { label: 't', size: 'sm' },
      { label: 'y', size: 'sm' },
      { label: 'u', size: 'sm' },
      { label: 'i', size: 'sm' },
      { label: 'o', size: 'sm' },
      { label: 'p', size: 'sm' },
      { label: '#@!', size: 'md', toggle: 'symbols' },
    ],
    [
      { label: 'a', size: 'sm' },
      { label: 's', size: 'sm' },
      { label: 'd', size: 'sm' },
      { label: 'f', size: 'sm' },
      { label: 'g', size: 'sm' },
      { label: 'h', size: 'sm' },
      { label: 'j', size: 'sm' },
      { label: 'k', size: 'sm' },
      { label: 'l', size: 'sm' },
      { label: '@', size: 'sm' },
      { label: 'áöû', size: 'md', toggle: 'accents' },
    ],
    [
      { label: 'z', size: 'sm' },
      { label: 'x', size: 'sm' },
      { label: 'c', size: 'sm' },
      { label: 'v', size: 'sm' },
      { label: 'b', size: 'sm' },
      { label: 'n', size: 'sm' },
      { label: 'm', size: 'sm' },
      { label: '_', size: 'sm' },
      { label: '.', size: 'sm' },
      { label: '-', size: 'sm' },
      { label: 'shift', size: 'md', toggle: 'uppercase' },
    ],
  ],

  uppercase: [
    [
      { label: 'Q', size: 'sm' },
      { label: 'W', size: 'sm' },
      { label: 'E', size: 'sm' },
      { label: 'R', size: 'sm' },
      { label: 'T', size: 'sm' },
      { label: 'Y', size: 'sm' },
      { label: 'U', size: 'sm' },
      { label: 'I', size: 'sm' },
      { label: 'O', size: 'sm' },
      { label: 'P', size: 'sm' },
      { label: '#@!', size: 'md', toggle: 'symbols' },
    ],
    [
      { label: 'A', size: 'sm' },
      { label: 'S', size: 'sm' },
      { label: 'D', size: 'sm' },
      { label: 'F', size: 'sm' },
      { label: 'G', size: 'sm' },
      { label: 'H', size: 'sm' },
      { label: 'J', size: 'sm' },
      { label: 'K', size: 'sm' },
      { label: 'L', size: 'sm' },
      { label: '@', size: 'sm' },
      { label: 'áöû', size: 'md', toggle: 'accents' },
    ],
    [
      { label: 'Z', size: 'sm' },
      { label: 'X', size: 'sm' },
      { label: 'C', size: 'sm' },
      { label: 'V', size: 'sm' },
      { label: 'B', size: 'sm' },
      { label: 'N', size: 'sm' },
      { label: 'M', size: 'sm' },
      { label: '_', size: 'sm' },
      { label: '.', size: 'sm' },
      { label: '-', size: 'sm' },
      { label: 'shift', size: 'md', toggle: 'lowercase' },
    ],
  ],

  symbols: [
    [
      { label: '!', size: 'sm' },
      { label: '@', size: 'sm' },
      { label: '#', size: 'sm' },
      { label: '$', size: 'sm' },
      { label: '%', size: 'sm' },
      { label: '^', size: 'sm' },
      { label: '&', size: 'sm' },
      { label: '*', size: 'sm' },
      { label: '(', size: 'sm' },
      { label: ')', size: 'sm' },
      { label: 'abc', size: 'md', toggle: 'lowercase' },
    ],
    [
      { label: '{', size: 'sm' },
      { label: '}', size: 'sm' },
      { label: '[', size: 'sm' },
      { label: ']', size: 'sm' },
      { label: ';', size: 'sm' },
      { label: '"', size: 'sm' },
      { label: ',', size: 'sm' },
      { label: '|', size: 'sm' },
      { label: '\\', size: 'sm' },
      { label: '/', size: 'sm' },
      { label: 'áöû', size: 'md', toggle: 'accents' },
    ],
    [
      { label: '<', size: 'sm' },
      { label: '>', size: 'sm' },
      { label: '?', size: 'sm' },
      { label: '=', size: 'sm' },
      { label: '\\', size: 'sm' },
      { label: '~', size: 'sm' },
      { label: '_', size: 'sm' },
      { label: ':', size: 'sm' },
      { label: '-', size: 'sm' },
      { label: '+', size: 'sm' },
      { label: 'shift', size: 'md', disabled: true },
    ],
  ],

  accents: [
    [
      { label: 'ä', size: 'sm' },
      { label: 'ë', size: 'sm' },
      { label: 'ï', size: 'sm' },
      { label: 'ö', size: 'sm' },
      { label: 'ü', size: 'sm' },
      { label: 'ÿ', size: 'sm' },
      { label: 'à', size: 'sm' },
      { label: 'è', size: 'sm' },
      { label: 'ì', size: 'sm' },
      { label: 'ò', size: 'sm' },
      { label: '#@!', size: 'md', toggle: 'symbols' },
    ],
    [
      { label: 'ù', size: 'sm' },
      { label: 'á', size: 'sm' },
      { label: 'é', size: 'sm' },
      { label: 'í', size: 'sm' },
      { label: 'ó', size: 'sm' },
      { label: 'ú', size: 'sm' },
      { label: 'ý', size: 'sm' },
      { label: 'â', size: 'sm' },
      { label: 'ê', size: 'sm' },
      { label: '@', size: 'sm' },
      { label: 'abc', size: 'md', toggle: 'lowercase' },
    ],
    [
      { label: 'î', size: 'sm' },
      { label: 'ô', size: 'sm' },
      { label: 'û', size: 'sm' },
      { label: 'ā', size: 'sm' },
      { label: 'ñ', size: 'sm' },
      { label: 'ń', size: 'sm' },
      { label: 'ź', size: 'sm' },
      { label: '_', size: 'sm' },
      { label: '.', size: 'sm' },
      { label: '-', size: 'sm' },
      { label: 'shift', size: 'md', toggle: 'uppercaseAccents' },
    ],
  ],

  uppercaseAccents: [
    [
      { label: 'Ä', size: 'sm' },
      { label: 'Ë', size: 'sm' },
      { label: 'Ï', size: 'sm' },
      { label: 'Ö', size: 'sm' },
      { label: 'Ü', size: 'sm' },
      { label: 'Ÿ', size: 'sm' },
      { label: 'À', size: 'sm' },
      { label: 'È', size: 'sm' },
      { label: 'Ì', size: 'sm' },
      { label: 'Ò', size: 'sm' },
      { label: '#@!', size: 'md', toggle: 'symbols' },
    ],
    [
      { label: 'Ù', size: 'sm' },
      { label: 'Á', size: 'sm' },
      { label: 'É', size: 'sm' },
      { label: 'Í', size: 'sm' },
      { label: 'Ó', size: 'sm' },
      { label: 'Ú', size: 'sm' },
      { label: 'Ý', size: 'sm' },
      { label: 'Â', size: 'sm' },
      { label: 'Ê', size: 'sm' },
      { label: '@', size: 'sm' },
      { label: 'abc', size: 'md', toggle: 'lowercase' },
    ],
    [
      { label: 'Î', size: 'sm' },
      { label: 'Ô', size: 'sm' },
      { label: 'Û', size: 'sm' },
      { label: 'Ā', size: 'sm' },
      { label: 'Ñ', size: 'sm' },
      { label: 'Ń', size: 'sm' },
      { label: 'Ź', size: 'sm' },
      { label: '_', size: 'sm' },
      { label: '.', size: 'sm' },
      { label: '-', size: 'sm' },
      { label: 'shift', size: 'md', toggle: 'accents' },
    ],
  ],
}

export const createKbLayout = (layoutType) => {
  const layout = [numbersRow, ...layoutType, actionsRow]

  return layout.map((row, index) => {
    return {
      type: QwertyKeyboardRow,
      rowIndex: index,
      keys: row,
    }
  })
}

export const createKey = (key: object, index: number, rowIndex: number) => {
  return {
    type: QwertyKeyboardKey,
    rowIndex,
    index,
    key,
  }
}
